import { Location } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-standard-list',
  templateUrl: './standard-list.component.html',
  styleUrl: './standard-list.component.scss'
})
export class StandardListComponent {
  constructor(private location: Location){}
  goBackToPrevPage(){
    this.location.back();
  }
}
